import React, {useState,useEffect} from 'react';
import SurfResultParagraphSelectBar from './SurfResultParagraphSelectBar';
import SurfResultParagraphList from './SurfResultParagraphList';
import webapi from '../../../api/webapi';
import EmptyDiv from '../Footer/EmptyDIV';
//import Loading from '../modal/Loading';
import '../../css/style.css';
import '../../css/react-tabs2.css';

const SurfResultParagraph = (props) =>{
    
    const [item,setItem]=useState('');
    //const [loadingShow,setLoadingShow]=useState(false);
    const [paragraphList,setParagraphList]=useState(undefined);
    
    useEffect(() => {setParagraphList('');},[props.selectedChapter,item])

    const GetParagraphList = async (item) => {
        props.setLoadingShow(true);
        setParagraphList('');

        //console.log('surf/paragraph/'+props.selectedBook+'/'+props.selectedChapter+'/'+item)
        await webapi.get('surf/paragraph/'+props.selectedBook+'/'+props.selectedChapter+'/'+item)
        .then(response => {
            setParagraphList(response.data)
            //console.log(response.data)
        }) 

        props.setLoadingShow(false);
    }

    const onSearchButtonClick = event =>{
        event.preventDefault();
        //console.log('item:',item)
        GetParagraphList(item)
    }

    return (
        [
            <div className="SearchBar" style={{margin:'0px auto 0px auto',width:'100%'}} key='a1'>
                <form>
                    <div className="divSearch">
                        <SurfResultParagraphSelectBar   pageData={props.pageData}
                                                        selectedBook={props.selectedBook}
                                                        selectedChapter={props.selectedChapter}
                                                        onSearchButtonClick={onSearchButtonClick}
                                                        setItem={setItem}
                                                        setLoadingShow={props.setLoadingShow}
                        />
                        <input className="submit_button" type="submit" value={props.pageData.length!==0 && props.pageData[0].F29901!== undefined?props.pageData[0].F29901:29901/*"جستجو"*/} onClick={onSearchButtonClick} />
                    </div>
                </form>
            </div>
            ,
            (paragraphList && paragraphList.length>0)
            ?
                <SurfResultParagraphList    paragraphList={paragraphList}
                                            pageData={props.pageData}
                                            selectedBookGroup={props.selectedBookGroup}
                                            key='a21'
                />
            :
                <EmptyDiv key='a22'/>
        ]
    );
}

export default SurfResultParagraph;